export default __webpack_public_path__ + "static/commmune-commonmistakes-f1cf79c3d9f68480871dfe0cd41afaa1.png";